var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.tallas,"label":"Tallas","no-data-text":"No hay datos disponibles","multiple":"","hide-details":"","solo":"","dense":"","outlined":"","flat":"","clearable":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }